import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../helper/bootstrap/Modal';
import { IFrame } from '../IFrame/IFrame';
import { getClassNameGenerator } from '../../helper/className';
import { withTranslate } from 'decorators/withTranslate';

const className = 'esk-information-popup-dialog';
const getClassName = getClassNameGenerator(className);

@withTranslate(withTranslate.MAIN)
export class InformationPopupDialog extends PureComponent {

  static propTypes = {
    t: PropTypes.func,
    contentUrl: PropTypes.string,
    onStopShowing: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
  };
  
  render() {
    const { t, contentUrl, onStopShowing, onClose } = this.props;
    
    return (
      <Modal className={className}>
        <ModalHeader onModalClose={onClose} />
        
        <ModalBody>
          <IFrame src={contentUrl} />
        </ModalBody>
        
        <ModalFooter>
          <u
            className={getClassName('dismiss-message', true)}
            onClick={onStopShowing}
          >
            {t('Do not show this message again')}
          </u>
        </ModalFooter>
      </Modal>
    );
  }
  
}
